export class NumberplateScanResult {
  public cameraIdentifier: string;
	public cameraName: string;
	public numberplate: string;
	public allowed = false;
	public scannedAt: string;

  constructor(scanResult: any) {
    if (scanResult != null) {
      this.cameraIdentifier = scanResult.cameraIdentifier;
      this.cameraName = scanResult.cameraName;
      this.numberplate = scanResult.numberplate;
      this.allowed = scanResult.allowed === true;
      this.scannedAt = scanResult.scannedAt;
    }
  }

}

export class NumberplateScanResults {

  public numberplateScans = new Array<NumberplateScanResult>();

  constructor(scanResults: any) {
    if (scanResults != null && scanResults.numberplateScans != null) {
      for (const scanResult of scanResults.numberplateScans) {
        this.numberplateScans.push(new NumberplateScanResult(scanResult));
      }
    }
  }
}
